// extracted by mini-css-extract-plugin
export var pillWrapper = "_ps-0";
export var showOverflow = "_ps-1";